import React, {useId, useRef, useState} from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material'

export default function ConfirmDeleteButton({label, subject, description, disabled, onConfirm}: {
  label: string
  subject: string
  description: string
  disabled: boolean
  onConfirm: () => void
}) {
  const [open, setOpen] = useState(false)
  const cancelRef = useRef<HTMLButtonElement>(null)
  const titleId = useId()
  const descriptionId = useId()
  return <>
    <Button variant="outlined" disabled={disabled} onClick={() => setOpen(true)}>{label}</Button>
    <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby={titleId} aria-describedby={descriptionId} slotProps={{transition: {onEntered: () => cancelRef.current?.focus()}}}>
      <DialogTitle id={titleId}>Delete {subject}?</DialogTitle>
      <DialogContent><DialogContentText id={descriptionId}>{description}</DialogContentText></DialogContent>
      <DialogActions>
        <Button ref={cancelRef} onClick={() => setOpen(false)}>Cancel</Button>
        <Button color="error" disabled={disabled} onClick={() => {setOpen(false); onConfirm()}}>Delete</Button>
      </DialogActions>
    </Dialog>
  </>
}
